import type {FC} from 'react';
import React from 'react';
import type {FieldError, UseFormRegister} from 'react-hook-form';
import clsx from 'clsx';

import {Paragraph} from '@/modules/foundation/components/typography/paragraph';

import type {FormData} from '../form';

type FormFieldProps = {
	name: ValidFieldNames;
	label: string;
	register?: UseFormRegister<FormData>;
	error?: FieldError;
	valueAsNumber?: boolean;
	required?: boolean;
	options: {value: string; label: string}[];
};

export type ValidFieldNames = 'subject';

export const SelectField: FC<FormFieldProps> = ({
	name,
	label,
	register,
	error,
	valueAsNumber,
	required,
	options,
}) => {
	return (
		<div className={clsx('grid', 'gap-1')}>
			<Paragraph asChild size="sm" className={clsx('font-semibold')}>
				<label htmlFor={name}>
					{label}
					{required && (
						<span
							aria-hidden
							className={clsx(error ? 'text-error-15' : 'text-primary-25')}
						>
							{' '}
							*
						</span>
					)}
				</label>
			</Paragraph>
			<select
				id={name}
				{...(required && {'aria-required': true})}
				{...(error && {'aria-invalid': true})}
				{...(register && register(name, {valueAsNumber}))}
				className={clsx(
					'focus-visible:ring-primary-25',
					'bg-white',
					error ? 'border-2' : 'border',
					error ? 'border-error-35' : 'border-grey-25',
					'rounded-lg',
					'shadow-[inset_0px_-2px_1px_0px_rgba(0,67,121,0.05),inset_3px_2px_6px_1px_rgba(0,67,121,0.03)]',
				)}
			>
				<option value="">Velg tema</option>
				{options.map(({value, label}) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</select>
			{error && (
				<Paragraph asChild size="xs">
					<span role="alert" className={clsx('text-error-15')}>
						{error.message}
					</span>
				</Paragraph>
			)}
		</div>
	);
};
